/**
 * Single dimmer device template
 * Used by: SPDM-001PE01EU
 */

import {
	createTurnAction,
	createStateCondition,
	createStateChangedTrigger,
} from '../../common/stateManagement.js';
import { createPowerLevelCondition, createPowerThresholdTrigger } from '../../common/powerMonitoring.js';
import {
	createSetBrightnessAction,
	createBrightnessLevelCondition,
	createBrightnessChangedTrigger,
} from '../../common/brightnessManagement.js';

export function createSingleDimmerTemplate() {
	return {
		deviceType: 'single_dimmer',
		channels: ['light:0'],
		actions: {
			turn: createTurnAction('Light.Set', 'on'),
			setBrightness: createSetBrightnessAction(),
		},
		conditions: {
			isOn: createStateCondition('output'),
			brightnessLevel: createBrightnessLevelCondition(),
			powerLevel: createPowerLevelCondition(2500),
		},
		triggers: {
			stateChanged: createStateChangedTrigger('output'),
			brightnessChanged: createBrightnessChangedTrigger(),
			powerThreshold: createPowerThresholdTrigger(2500),
		},
	};
}
